
import { Pagination, Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { AlertScreen } from "../../components/AlertScreen";
import { coloresTipoNoti, envVariables } from "../../../../helpers";
import { useModalesStore, useNotificacionesStore } from "../../../../store";
import { TooltipAndIcon } from "../../components/TooltipAndIcon";
import { LayoutTabla } from "../../../layout";

import dayjs from "dayjs";
const paginado = Number(envVariables.REACT_APP_PAGINADO);




export const TablaNotificaciones = ({ data, chagePage=null, page=0 }) => {


    const { totalNotificacion, infoActiveNotificacion } = useNotificacionesStore();
    const { changeEstadoModalUno } = useModalesStore(); 


    const handleAprobar = ({ id, estado }) => {
        infoActiveNotificacion({ id, estado })
        changeEstadoModalUno(true);
    }


    
    return (
        <>
        {(data.length > 0) 
        ?   <LayoutTabla
                paginado={
                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalNotificacion / paginado)}  disabled={Math.ceil(totalNotificacion / paginado) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'15%'}}>FECHA</TableCell>
                        <TableCell sx={{width:'20%'}}>PRODUCTO</TableCell>
                        <TableCell sx={{width:'10%'}}>CANTIDAD</TableCell>
                        <TableCell sx={{width:'15%'}}>DE</TableCell>
                        <TableCell sx={{width:'15%'}}>PARA</TableCell>
                        <TableCell sx={{width:'15%'}}>ESTADO</TableCell>
                        <TableCell sx={{width:'15%'}}>ACCION</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {data.map( (pro) => (
                    <TableRow key={ pro.id }>
                        <TableCell>{ dayjs(pro.createdAt).format('DD/MM/YYYY') }</TableCell>
                        <TableCell >{ pro.producto.nombre  }</TableCell>
                        <TableCell >{ pro.cantidad  }</TableCell>
                        <TableCell>{ pro?.de?.nombre }</TableCell>
                        <TableCell>{ pro?.para?.nombre }</TableCell>
                        <TableCell sx={{color: coloresTipoNoti[pro.estado] }}>{ pro.estado }</TableCell>
                        
                        <TableCell>
                            <TooltipAndIcon
                                titulo='Aprobar Traslado'
                                icono='terminada'
                                onClick={ () => handleAprobar({ id:pro.id, estado:'Aprobar' }) }
                                color={(pro.estado === "PENDIENTE") ? 'green' : 'gray'}
                                disabled={pro.estado !== "PENDIENTE"}
                            />

                            <TooltipAndIcon
                                titulo='Denegada Traslado'
                                icono='cerrar'
                                onClick={ () => handleAprobar({ id:pro.id, estado:'Denegar' }) }
                                color={(pro.estado === "PENDIENTE") ? 'red' : 'gray'}
                                disabled={pro.estado !== "PENDIENTE"}
                            />
                        </TableCell>

                    </TableRow>
                ))}
                </TableBody>
            </LayoutTabla>
        
        :   <AlertScreen title="No hay notificaciones por el momento..."/>
        }
        </>
    )
}
